$(window).on('load', function () {
    var overview = $('.mxm_berufe.default');
    if (!overview.length) {
        return;
    }

    if ($('[data-toggle="tab"].active').length) {
        var url = $('[data-toggle="tab"].active').first().data('taburl');
        var title = $('[data-toggle="tab"].active').first().text();
        setActivePath(url, title);
    }

    $('[data-toggle="tab"]').on('click', function() {
        var url = $(this).data('taburl');
        var title = $(this).text();
        setActivePath(url, title);
    });

    function setActivePath(url, title) {
        window.history.replaceState(url, title, url);
    }
});